module.exports = __webpack_public_path__ + "img/dian.6833bbd1.png";